import Http from "@/common/lib/http";

export const getDefaultUser = async () => {
    const { data } = await Http.instance.get("/bo/auth/default-user");
    return data;
};
